module.exports = __webpack_public_path__ + "static/media/logo-inceptia.851fbaae.png";